import React from 'react';

/**
 * ConsultantDashboardErrorBanner
 *
 * Props:
 * - error: string | null
 * - onRetry: () => void
 */
const ConsultantDashboardErrorBanner = ({ error, onRetry }) => {
  if (!error) return null;

  return (
    <div className="mb-6 bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 rounded-lg p-4">
      <div className="flex items-start">
        <svg
          className="h-5 w-5 text-red-600 dark:text-red-400 mr-3 mt-0.5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <div className="flex-1">
          <p className="text-red-800 dark:text-red-300 font-medium">
            Error loading dashboard
          </p>
          <p className="text-red-700 dark:text-red-400 text-sm">{error}</p>
        </div>
        <button
          onClick={onRetry}
          className="ml-4 text-red-600 dark:text-red-400 hover:text-red-700 dark:hover:text-red-300 font-medium text-sm"
        >
          Retry
        </button>
      </div>
    </div>
  );
};

export default ConsultantDashboardErrorBanner;


